import axios from "axios";
import React, { useEffect, useState } from "react";
import baseUrl from "../../baseUrl";
import HomeCarousel from "../../Components/HomeCarousel/HomeCarousel";
import HomeShowcaseCard from "../../Components/HomeShowcaseCard/HomeShowcaseCard";
import Spinner from "../../Components/Spinner/Spinner";
import EmptyData from "../../Components/EmptyData/EmptyData";
import { Link } from "react-router-dom";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [trendingBlogs, setTrendingBlogs] = useState([]);
  const [popularBlogs, setPopularBlogs] = useState([]);

  // Trending Blogs
  useEffect(() => {
    setLoading(true);
    axios
      .post(`${baseUrl}/blog/trending-blogs`)
      .then((response) => {
        setTrendingBlogs(response.data.blogs);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, []);
  // Trending Blogs
  useEffect(() => {
    setLoading(true);
    axios
      .post(`${baseUrl}/blog/popular-blogs`)
      .then((response) => {
        setPopularBlogs(response.data.blogs);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, []);

  // Trending Blogs
  return (
    <>
      {loading && <Spinner />}
      <HomeCarousel />
      <hr />
      {/* Trending Blogs  */}
      {trendingBlogs.length <= 0 ? (
        <EmptyData message={"Oops! No trending blogs."} />
      ) : (
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-5 mx-auto">
            <div className="flex">
              <h1 className="text-2xl font-bold text-gray-900 p-4">
                Trending Blogs
              </h1>
              <Link
                className="text-xl underline font-bold text-indigo-600 p-4"
                to="/blogs"
              >
                Explore More
              </Link>
            </div>
            <div className="flex flex-wrap -m-4">
              {trendingBlogs.map((blog) => (
                <HomeShowcaseCard key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        </section>
      )}
      {/* Trending Blogs  */}

      {/* Popular Blogs  */}
      {popularBlogs.length <= 0 ? (
        <EmptyData message={"Oops! No popular blogs."} />
      ) : (
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-5 mx-auto">
            <div className="flex">
              <h1 className="text-2xl font-bold text-gray-900 p-4">
                Popular Blogs
              </h1>
              <Link
                className="text-xl underline font-bold text-indigo-600 p-4"
                to="/blogs"
              >
                Explore More
              </Link>
            </div>
            <div className="flex flex-wrap -m-4">
              {popularBlogs.map((blog) => (
                <HomeShowcaseCard key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        </section>
      )}
      {/* Trending Blogs  */}
    </>
  );
};

export default Home;
